'use strict';

var validator = require('validator');
var y = require('yup');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

function _interopNamespaceCompat(e) {
  if (e && typeof e === 'object' && 'default' in e) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var validator__default = /*#__PURE__*/_interopDefaultCompat(validator);
var y__namespace = /*#__PURE__*/_interopNamespaceCompat(y);

const name = 'postalCode';
const POSTAL_CODE_ERROR = 'postalCode';
const isPostalCodeLocale = (country)=>{
    return validator__default.default.isPostalCodeLocales.includes(country);
};
y__namespace.addMethod(y__namespace.StringSchema, name, function(options) {
    return this.test({
        name,
        message: {
            key: options?.error ?? POSTAL_CODE_ERROR
        },
        test: (postalcode)=>{
            if (!postalcode) {
                return false;
            }
            // Since the country may be outside the validation set, the zip may be valid
            // and the validator may respond false even if passed 'any', so if the countryCode isn't
            // a valid postalCodeLocale, we choose to not attempt to validate.
            return options?.countryCode != null && isPostalCodeLocale(options.countryCode) ? validator__default.default.isPostalCode(postalcode, options?.countryCode) : true;
        }
    });
});

exports.POSTAL_CODE_ERROR = POSTAL_CODE_ERROR;
//# sourceMappingURL=postalCode.js.map
